import React from 'react';
import PropTypes from 'prop-types';
import { useGetDigitalDataFlagValue } from '../../utils/digital-data-flag';
import returnReasonsShape from '../return-reasons-shape';
import ProductCategoryListEnhanced from './product-category-list-enhanced';
import ProductCategoryListLegacy from './product-category-list-legacy';
import productsShape from './products-shape';

export default function ProductCategoryList({
  orderItems,
  products,
  selectedProducts,
  returnReasonCodeList,
  selectedProductComments,
  handleSelectedProduct,
  handleUpdateComments,
  category,
  showEligible,
  returnReasons,
  eligibility,
}) {
  const usingReturnReasons = useGetDigitalDataFlagValue('ful-dre-2-0-updated-reason-codes', false);
  if (usingReturnReasons) {
    return (
      <ProductCategoryListEnhanced
        products={products}
        selectedProducts={selectedProducts}
        selectedProductComments={selectedProductComments}
        returnReasons={returnReasons}
        handleSelectedProduct={handleSelectedProduct}
        handleUpdateComments={handleUpdateComments}
        category={category}
        eligibility={eligibility}
      />
    );
  }

  return (
    <ProductCategoryListLegacy
      products={orderItems}
      selectedProducts={selectedProducts}
      selectedProductComments={selectedProductComments}
      returnReasonCodeList={returnReasonCodeList}
      handleSelectedProduct={handleSelectedProduct}
      handleUpdateComments={handleUpdateComments}
      category={category}
      showEligible={showEligible}
      eligibility={eligibility}
    />
  );
}

ProductCategoryList.propTypes = {
  orderItems: productsShape,
  products: productsShape,
  selectedProducts: productsShape.isRequired,
  returnReasonCodeList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          label: PropTypes.string,
          type: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  selectedProductComments: PropTypes.shape({
    exchangeReason: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          label: PropTypes.string,
          type: PropTypes.string,
        }),
      ),
    }),
    exchangeSecondaryReason: PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      type: PropTypes.string,
    }),
    exchangeComment: PropTypes.string,
  }).isRequired,
  handleSelectedProduct: PropTypes.func.isRequired,
  handleUpdateComments: PropTypes.func.isRequired,
  category: PropTypes.string,
  showEligible: PropTypes.bool,
  returnReasons: returnReasonsShape,
  eligibility: PropTypes.string,
};
